import { useEmailReviewStore } from "../../stores/emailReviewStore";
import EditorMessage from "../EditorMessage";

export default function EmailReviewBanner({ userId, isPaid = false }: { userId?: string; isPaid?: boolean }) {
  const flaggedUserId = useEmailReviewStore((state) => state.userId);
  if (!userId || flaggedUserId !== userId || isPaid) return null;

  return (
    <EditorMessage
      role="alert"
      message="Free AI generation is restricted for this account. You can still access and edit your writing."
      buttonText="Request a review"
      url="mailto:hi@sudowrite.com?subject=Free%20AI%20access%20review"
    />
  );
}
